import React, { Component } from "react";
import { Form, Col, Input, Select } from "antd";
import ListPage from "../../../../../components/ListPage";
import styles from "./search.less";

const { ListSearch } = ListPage;
const { Item } = Form;

const activityStatus = [
  {
    key: "",
    value: "全部"
  },
  {
    key: 0,
    value: "草稿"
  },
  {
    key: 1,
    value: "进行中"
  },
  {
    key: 2,
    value: "已结束"
  }
];

class Search extends Component {
  handleSubmit = values => {
    const { handleQueryChange } = this.props;
    handleQueryChange({ query: values });
  };

  handleReset = () => {
    const { handleQueryChange, form } = this.props;
    const { resetFields, getFieldsValue } = form || {};
    resetFields();
    handleQueryChange({
      query: { ...getFieldsValue() }
    });
  };

  render() {
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      colon: true,
      labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 17 },
        sm: { span: 17 }
      }
    };

    const searchProps = {
      form,
      btnSmSpan: 24,
      btnLgSpan: 24,
      handleQuery: this.handleSubmit,
      handleReset: this.handleReset,
      className: styles.root,
      buttonColProps: {
        style: {
          lineHeight: "unset",
          textAlign: "right"
        }
      }
    };

    return (
      <ListSearch {...searchProps}>
        <Col span={8}>
          <Item label="活动名称" {...formItemLayout}>
            {getFieldDecorator("activityName", {
              initialValue: ""
            })(<Input placeholder="请搜索活动名称" />)}
          </Item>
        </Col>
        <Col span={8}>
          <Item label="创建人" {...formItemLayout}>
            {getFieldDecorator("userName", {
              initialValue: ""
            })(<Input placeholder="请搜索创建人" />)}
          </Item>
        </Col>
        <Col span={8}>
          <Item label="活动状态" {...formItemLayout}>
            {getFieldDecorator("status", {
              initialValue: ""
            })(
              <Select placeholder="请搜索活动状态">
                {activityStatus.map(item => {
                  return (
                    <Select.Option value={item.key}>{item.value}</Select.Option>
                  );
                })}
              </Select>
            )}
          </Item>
        </Col>
      </ListSearch>
    );
  }
}

export default Search;
